<template>
  <div
    class="preview"
    :class="[computedCharacterColorClass]"
  >
    <!-- character-code for mixin.character -->
    <component
      v-if="true"
      :is="computedComponentName"
      :character-code="characterColor"
      :columns="detail.columns"
      :typography="detail.typography"
      :is-sanskrit-character-back-needed="computedIsSanskritCharacterBackNeeded"
      :sanskrit-character-back="detail.sanskritCharacterBack"
      :custom-sanskrit-character-back-url="detail.customSanskritCharacterBackUrl"
      :secular-name-prefix="detail.secularNamePrefix"
      :secular-name-prefix-placement="detail.secularNamePrefixPlacement"
      :age-unit-character="detail.ageUnitCharacter"
      :age-at-death-prefix="detail.ageAtDeathPrefix"
      :age-at-death-prefix-placement="detail.ageAtDeathPrefixPlacement"
      :died-character="detail.diedCharacter"
      @onClickCharacter="$listeners['onClickCharacter']"
    />
  </div>
</template>

<script>
// 通常位牌 1霊
import N1East from "@/components/Common/TabletPreview/Items/Layouts/N1East/Back.vue";
import N1West from "@/components/Common/TabletPreview/Items/Layouts/N1West/Back.vue";
// 通常位牌 2霊
import N2East from "@/components/Common/TabletPreview/Items/Layouts/N2East/Back.vue";
import N2East2 from "@/components/Common/TabletPreview/Items/Layouts/N2East2/Back.vue";
import N2East3 from "@/components/Common/TabletPreview/Items/Layouts/N2East3/Back.vue";
import N2West from "@/components/Common/TabletPreview/Items/Layouts/N2West/Back.vue";
import N2West2 from "@/components/Common/TabletPreview/Items/Layouts/N2West2/Back.vue";
import N2West3 from "@/components/Common/TabletPreview/Items/Layouts/N2West3/Back.vue";
// 俗名位牌 1霊
import S1East from "@/components/Common/TabletPreview/Items/Layouts/S1East/Back.vue";
import S1West from "@/components/Common/TabletPreview/Items/Layouts/S1West/Back.vue";
// マインドアルテ 1霊
import M1A from "@/components/Common/TabletPreview/Items/Layouts/M1A/Back.vue";
import M1B from "@/components/Common/TabletPreview/Items/Layouts/M1B/Back.vue";
// マインドアルテ 2霊
import M2 from "@/components/Common/TabletPreview/Items/Layouts/M2/Back.vue";

// Mixins
import TabletPreviewMixin from "@/mixins/tabletPreview.mixin";

export default {
  mixins: [
    TabletPreviewMixin.component,
    TabletPreviewMixin.character,
  ],
  components: {
    N1East,
    N1West,
    N2East,
    N2East2,
    N2East3,
    N2West,
    N2West2,
    N2West3,
    S1East,
    S1West,
    M1A,
    M1B,
    M2,
  },
  props: {
    detail: {
      type: Object,
      required: true,
    },
  },
  mounted () {},
  data () {
    return {
    };
  },
  computed: {
    computedIsSanskritCharacterBackNeeded () {
      const {
        $route,
        detail,
      } = this;

      const {
        customSanskritCharacterBackUrl,
        sanskritCharacterBack,
        isSanskritCharacterBackNeeded,
      } = detail;

      // 注文詳細画面の場合
      if (
        $route.name === "order-detail" ||
        $route.name === "orderconfirm" ||
        $route.name === "admin-order-detail" ||
        $route.name === "admin-order-print-preview"
      ) {
        // isShow = order.detail.isSanskritCharacterBackNeeded;
        return customSanskritCharacterBackUrl !== null || sanskritCharacterBack !== null;
      }

      // 注文編集画面の場合で Object で保持されている場合
      if (typeof isSanskritCharacterBackNeeded === "object") {
        return true;
      }

      // 注文編集画面の場合で Boolean の場合
      if (typeof isSanskritCharacterBackNeeded === "boolean") {
        return isSanskritCharacterBackNeeded;
      }

      // 上記に該当しない場合、非表示
      return false;
    },
  },
  watch: {},
  destroyed () {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/tablet-common.scss";
</style>
